import { useState } from 'react'
import { Outlet } from 'react-router-dom'
import { Box, Toolbar, useMediaQuery, useTheme } from '@mui/material'
import Header from './Header'
import Sidebar from './Sidebar'
import { useUIStore } from '@store/uiStore'
import { useTranslation } from '@i18n'

const DRAWER_WIDTH = 260

const DashboardLayout = () => {
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down('md'))
    const [mobileOpen, setMobileOpen] = useState(false)
    const { sidebarCollapsed } = useUIStore()
    const { language } = useTranslation()

    const isRTL = language === 'ar'

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen)
    }

    return (
        <Box sx={{ display: 'flex', minHeight: '100vh', direction: isRTL ? 'rtl' : 'ltr' }}>
            <Header onMenuClick={handleDrawerToggle} />

            {/* Mobile Drawer */}
            <Sidebar
                variant="temporary"
                open={mobileOpen}
                onClose={handleDrawerToggle}
            />

            {/* Desktop Drawer */}
            <Sidebar variant="permanent" />

            {/* Main Content */}
            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    p: 3,
                    width: { xs: '100%', md: `calc(100% - ${sidebarCollapsed ? 72 : DRAWER_WIDTH}px)` },
                    minHeight: '100vh',
                    bgcolor: 'background.default',
                    transition: 'width 0.2s ease, margin 0.2s ease',
                    marginLeft: { xs: 0, md: isRTL ? 0 : 0 },
                    marginRight: { xs: 0, md: isRTL ? 0 : 0 },
                }}
            >
                <Toolbar />
                <Box
                    sx={{
                        maxWidth: 1400,
                        mx: 'auto',
                        animation: 'fadeIn 0.3s ease-out',
                    }}
                >
                    <Outlet />
                </Box>
            </Box>
        </Box>
    )
}

export default DashboardLayout

